@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.rma-link {
  &:disabled {
    color: @rma-number-link--disabled--text-color;
    &:hover {
      color: @rma-number-link--disabled--text-color;
    }
  }
}
